module.exports = __webpack_public_path__ + "static/media/ChangePassword.22bd3b59.png";